import React from 'react';
import PropTypes from 'prop-types';
import styles from './Resources.module.css';

import { useAnalytics } from 'hooks/useAnalytics';

const linkShape = PropTypes.shape({
  displayText: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
}).isRequired;
const analyticsShape = PropTypes.shape({
  category: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}).isRequired;
const resourceShape = PropTypes.shape({
  link: linkShape.isRequired,
  description: PropTypes.string.isRequired,
  analytics: analyticsShape.isRequired,
}).isRequired;

const propTypes = { resourceDetail: PropTypes.shape(resourceShape).isRequired };

function Resource({ resourceDetail }) {
  const handleClick = (event, target) => {
    event.preventDefault();
    window.open(target);
  };

  const { handleItemClick } = useAnalytics(
    resourceDetail.analytics.category,
    'navigate-to-resource',
    resourceDetail.analytics.label,
    '',
    handleClick
  );

  const ariaLabel = `${resourceDetail.link.displayText}. ${resourceDetail.description}`;
  return (
    <div className={styles['resource-item']} onClick={(event) => handleItemClick(event, resourceDetail.link.target)}>
      <a className={styles['link']} href={resourceDetail.link.target} aria-label={ariaLabel}>
        {resourceDetail.link.displayText}
      </a>
      <p className={styles['description']} aria-hidden={true}>
        {resourceDetail.description}
      </p>
    </div>
  );
}

Resource.propTypes = propTypes;

export default Resource;
